import React, { memo, useMemo } from 'react'

import { bool, func, string } from 'prop-types'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { POLYGON_TYPE } from 'Pods/ThreeDStudio/Store/constants'

function GenericPolygonTypeSelector({
  handleQuadrilateralClick,
  handleTriangleClick,
  sliceName,
  storeSchemaKey,
  forceDisabled = false,
}) {
  const t = useTranslation()
  const { isFullyDisabled, disabledValues } = useDisabledSelector('polygon_type', storeSchemaKey)

  const buttons = useMemo(() => [
    {
      id: POLYGON_TYPE.QUADRILATERAL,
      label: t('shared.polygonType.quad'),
      onClick: handleQuadrilateralClick,
      disabled: forceDisabled || isFullyDisabled || disabledValues.includes(POLYGON_TYPE.QUADRILATERAL),
    },
    {
      id: POLYGON_TYPE.TRIANGLE,
      label: t('shared.polygonType.triangular'),
      onClick: handleTriangleClick,
      disabled: forceDisabled || isFullyDisabled || disabledValues.includes(POLYGON_TYPE.TRIANGLE),
    },
  ], [
    t,
    forceDisabled,
    isFullyDisabled,
    disabledValues,
    handleQuadrilateralClick,
    handleTriangleClick,
  ])

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="polygonType"
      sliceName={sliceName}
      label={t('shared.polygonType.label')}
    />
  )
}

GenericPolygonTypeSelector.propTypes = {
  handleQuadrilateralClick: func.isRequired,
  handleTriangleClick: func.isRequired,
  sliceName: string.isRequired,
  storeSchemaKey: string.isRequired,
  forceDisabled: bool,
}

export default memo(GenericPolygonTypeSelector)
